export class AdminSubscriptionCompanyAddress {
  label: string

  street: string

  number: string

  complement: string

  neighborhood: string

  city: string

  state: string

  zipCode: string

  country: string

  latitude?: number

  longitude?: number

  constructor(data: Partial<AdminSubscriptionCompanyAddress> = {}) {
    this.label = data.label ?? ""

    this.street = data.street ?? ""

    this.number = data.number ?? ""

    this.complement = data.complement ?? ""

    this.neighborhood = data.neighborhood ?? ""

    this.city = data.city ?? ""

    this.state = data.state ?? ""

    this.zipCode = data.zipCode ?? ""

    this.country = data.country ?? ""

    this.latitude = data.latitude

    this.longitude = data.longitude
  }
}
